// Allowed values for a tenant's `tenantType` configuration field.
// Mirrors the values accepted by the mos-mvp tenant APIs.
export const TENANT_TYPES = ['Customer', 'Prospect', 'Internal'] as const;
export type TenantType = (typeof TENANT_TYPES)[number];
export const DEFAULT_TENANT_TYPE: TenantType = 'Internal';
